import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Label } from 'src/app/labels/englishLabels';
import { PlatformToAuthenticationMethodsSelectOptions } from 'src/app/models/selectOptions';

@Component({
  selector: 'app-integration-auth-method',
  templateUrl: './integration-auth-method.component.html',
  styleUrls: ['./integration-auth-method.component.scss'],
})
export class IntegrationAuthMethodComponent implements OnInit {
  @Input() public isInAddMode: boolean;
  @Input() public platformControl: FormControl<string>;
  @Input() public authMethodControl: FormControl<string>;

  public platformToAuthenticationMethodsSelectOptions = PlatformToAuthenticationMethodsSelectOptions;
  public selectedAuthMethodDisplayName: string;

  ngOnInit() {
    this._updateSelectedAuthMethodDisplayName();

    this.platformControl.valueChanges.subscribe((platform) => {
      const platformAuthMethods = this.platformToAuthenticationMethodsSelectOptions[platform];

      if (platformAuthMethods?.length === 1) {
        this.authMethodControl.setValue(platformAuthMethods[0].id);
      } else {
        this.authMethodControl.reset();
      }
    });

    this.authMethodControl.valueChanges.subscribe(() => {
      this._updateSelectedAuthMethodDisplayName();
    });
  }

  private _updateSelectedAuthMethodDisplayName() {
    if (this.platformControl.value) {
      this.selectedAuthMethodDisplayName = Label.get(
        this.platformToAuthenticationMethodsSelectOptions[this.platformControl.value].find(
          (option) => option.id == this.authMethodControl.value
        )?.displayName ?? ''
      );
    }
  }
}
